import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import AsyncComponentErrorHandler from 'framework-asset-preview-lib/internal/shared/components/AsyncComponentErrorHandler';
export default Loadable({
  loader: () => import( /* webpackChunkName: "marketing-sms-object-status-details" */'messaging-publishing-lib/components/SmsStateStatusPill').then(mod => mod.default).catch(AsyncComponentErrorHandler('marketing-sms-object-status-details')),
  LoadingComponent: () => null
});